// import dJSON from 'dirty-json';
// import '../node_modules/@lottiefiles/lottie-player/dist/lottie-player';

import './js/base/base-start';
import './js/global';

// modules - core
import './modules/core/accordion/module';

// modules
import './modules/theme/hero-slider/module';
import './modules/evox/category-cards/module';
import './modules/theme/tabbed-services/module';
import './modules/theme/locations/module';
import './modules/theme/testimonials/module';

// layouts

// leave me last
import './js/base/base-end';
